import React, { useState } from "react";
import { Menu, Avatar, Space, Dropdown } from "antd";
import {
  MenuFoldOutlined,
  UserOutlined,
  LogoutOutlined,
  MenuUnfoldOutlined,
} from "@ant-design/icons";
import "./Navbar.css";
import { Link } from "react-router-dom";
import moment from "moment";

function Navbar(props) {
  const [dropDown, setDropDown] = useState("false");
  const { history } = props;

  const handleLogout = () => {
    console.log("terclick");
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("_id");
    sessionStorage.removeItem("permissions");
    sessionStorage.removeItem("fullname");
    sessionStorage.removeItem("avatar");
    sessionStorage.removeItem("redirect");

    return history.push("/login");
  };

  return (
    <>
      <nav className="header-navbar navbar navbar-expand-lg align-items-center floating-nav navbar-light navbar-shadow container-xxl">
        <div className="navbar-container d-flex content">
          <div className="bookmark-wrapper d-flex align-items-center"></div>
          <ul className="nav navbar-nav align-items-center ml-auto">
            <li className="nav-item text-white font-weight-bolder">
              {moment(new Date()).format("DD MMMM YYYY")}
            </li>
            <li
              className={`nav-item dropdown dropdown-user ${
                dropDown ? "" : "show"
              }`}>
              <a
                className="nav-link dropdown-toggle dropdown-user-link"
                onClick={() => setDropDown(!dropDown)}
                id="dropdown-user"
                href="javascript:void(0);"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false">
                <div className="user-nav d-sm-flex d-none">
                  <span className="user-name font-weight-bolder">
                    {sessionStorage.getItem("fullname")}
                  </span>
                  <span className="user-status">Admin</span>
                </div>
                <span className="avatar">
                  {sessionStorage.getItem("avatar") ? (
                    // <Avatar size="small" src={sessionStorage.getItem('avatar')} />
                    <img
                      className="round"
                      src={sessionStorage.getItem("avatar")}
                      alt="avatar"
                      height="40"
                      width="40"></img>
                  ) : (
                    <Avatar size="small" icon={<UserOutlined />} />
                  )}
                  <span className="avatar-status-online"></span>
                </span>
              </a>
              <div
                className="dropdown-menu dropdown-menu-right mt-2"
                aria-labelledby="dropdown-user">
                {/* <a className="dropdown-item" href="page-profile.html">
                        <i className="mr-50" data-feather="user"></i> Profile
                      </a>
                      <div className="dropdown-divider"></div>
                      <a className="dropdown-item" href="page-account-settings.html">
                        <i className="mr-50" data-feather="settings"></i> Settings
                      </a> */}
                <Link to="/profile">
                  <a className="dropdown-item">
                    <i className="" data-feather="power"></i> Profile
                  </a>
                </Link>
                <a className="dropdown-item" onClick={handleLogout}>
                  <i className="" data-feather="power"></i> Logout
                </a>
              </div>
            </li>
          </ul>
        </div>
      </nav>
    </>
    // <div className="navbar">
    //   <div>
    //     { collapsed ? <MenuUnfoldOutlined onClick={onToggleCollapsed} /> : <MenuFoldOutlined onClick={onToggleCollapsed} /> }
    //   </div>
    //   {/* <div>
    //             {moment(new Date()).format('DD MMMM YYYY')}
    //         </div> */}
    //   <div>
    //     <Menu mode="horizontal" className="menu-header">
    //       <Menu.Item key="profile">
    //         <Dropdown
    //           overlay={(
    //             <Menu>
    //               <Menu.Item key="3">
    //                 <span onClick={handleLogout}>
    //                   <LogoutOutlined />
    //                   Logout
    //                 </span>
    //               </Menu.Item>
    //             </Menu>
    //                       )}
    //           trigger={['click']}
    //         >
    //           <a className="ant-dropdown-link" onClick={(e) => e.preventDefault()}>
    //             <Space>
    //               {
    //                                     sessionStorage.getItem('avatar') ? (
    //                                       <Avatar size="small" src={sessionStorage.getItem('avatar')} />
    //                                     ) : (
    //                                       <Avatar size="small" icon={<UserOutlined />} />
    //                                     )
    //                                 }
    //               { !screens.xs && (
    //               <span>
    //                 {' '}
    //                 { sessionStorage.getItem('fullname') }
    //                 {' '}
    //               </span>
    //               ) }
    //             </Space>
    //           </a>
    //         </Dropdown>
    //       </Menu.Item>
    //     </Menu>
    //   </div>
    // </div>
  );
}

export default Navbar;
